// @ts-strict-ignore
import {Component, Input} from "@angular/core";
import {Translations} from "@translations";
import {FontAwesomeCode, SearchableColumn} from "@models";
import {LoadingConfig} from "../basic-page-layout/basic-page-layout.component";
import {FilterActions} from "../../administration-table/administration-table-advanced-search/administration-table-advanced-search.component";

@Component({
	selector: "sim-administration-table-page-layout",
	templateUrl: "./administration-table-page-layout.component.html",
	styleUrl: "./administration-table-page-layout.component.scss",
	standalone: false,
})
export class AdministrationTablePageLayoutComponent {
	protected readonly T = Translations;

	@Input({required: true}) headerToken: keyof typeof Translations;
	@Input({required: true}) headerIcon: FontAwesomeCode;
	@Input() loadingConfig?: LoadingConfig;
	@Input() backUrl: string;

	// Filter Config
	@Input() filterActions: FilterActions | null;
	@Input() searchableColumns: SearchableColumn[] | null;
}
